<template>
  <span class="font-semibold">
    <slot />
  </span>
</template>

<script setup></script>
